// extracted by mini-css-extract-plugin
module.exports = {"tag":"style__tag__bYmxw","green":"style__green__9kk76","red":"style__red__M04W7","yellow":"style__yellow__YAPkv"};